import {STENCILCONST} from '../modules/constant.js.erb'

const textFont = 'Caslon'
const textFontClass = 'font-caslon'
const textHeight = 10
const material = STENCILCONST.materialLetter[0].value

const oldTab = 0
const activeTab = 0

const items = []

const state = {
  textFont,
  textFontClass,
  textHeight,
  material,
  oldTab,
  activeTab,
  items
}

const findMaterialByValue = value =>
  STENCILCONST.materialLetter.filter(m => m.value == state.material)[0];

const onlyMaterialsForHeight = height =>
  computedMaterialsForHeight(height).filter(m => m.available);

const computedMaterialsForHeight = height =>
  STENCILCONST.materialLetter.map(m =>  ({...m, available: (m.maxHeight >= height)}));

const getters = {
  materials: state => computedMaterialsForHeight(state.textHeight),
  material: state => state.material
}

const mutations = {
  setTextFont: (state, payload) => state.textFont = payload,
  setTextFontClass: (state, payload) => state.textFontClass = payload,
  setTextHeight: (state, height) => {
    state.textHeight = height;

    const materialObject = findMaterialByValue(state.material);

    if(materialObject.maxHeight < height) {
      state.material = onlyMaterialsForHeight(height)[0].value;
    }
  },
  setMaterial: (state, payload) => state.material = payload,
  setOldTab: (state, payload) => state.oldTab = payload,
  setActiveTab: (state, payload) => state.activeTab = payload,
  setItems: (state, payload) => state.items = payload
}

const actions = {
  SET_TEXT_FONT: ({ commit }, payload) => commit('setTextFont', payload),
  SET_FONT_CLASS: ({ commit }, payload) => commit('setTextFontClass', payload),
  SET_HEIGHT: ({ commit }, payload) => commit('setTextHeight', payload),
  SET_MATERIAL: ({ commit }, payload) => commit('setMaterial', payload),
  SET_OLDTAB: ({ commit }, payload) => commit('setOldTab', payload),
  SET_ACTIVETAB: ({ commit }, payload) => commit('setActiveTab', payload),
  SET_ITEMS: ({ commit }, payload) => commit('setItems', payload)
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
